import { AddressFieldType } from '..';

export const BASE_FIELDNAMES: Record<AddressFieldType, string> = {
  current: 'credit.customer_details.current_address',
  previous1: 'credit.customer_details.previous_address_one',
  previous2: 'credit.customer_details.previous_address_two',
};
